import { configureStore } from "@reduxjs/toolkit";

import machineReducer from "./slices/machine-slice";
import frequencyReducer from "./slices/frequency-slice";
import capsulesReducer from "./slices/capsules-slice";

import { productApi } from "./services/productApi";
import { dynamicBoxApi } from "./services/dynamicBoxApi";

const store = configureStore({
  reducer: {
    machine: machineReducer,
    frequency: frequencyReducer,
    capsules: capsulesReducer,
    [productApi.reducerPath]: productApi.reducer,
    [dynamicBoxApi.reducerPath]: dynamicBoxApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(productApi.middleware, dynamicBoxApi.middleware),
});

export default store;
